<template>
  <h1>Reb's Image SEO Renamer BETA</h1>
  <p>Upload a max of 10 images at a time to avoid API overages <br />and successfully download them all at once.</p>
  <form class="imageupload">
    <table cellpadding="5">
      <tbody>
        <tr>
          <td>
            <label for="aimodel">AI Model: </label>
            <select name="aimodel" id="aimodel">
              <option v-for="(item, i) in $store.state.aimodels" :key="i" :selected="item.selected">{{ item.model }}</option>
            </select>
          </td>
        </tr>
      </tbody>
    </table>
    <table cellpadding="5">
      <tbody>
        <tr>
          <td>
            <label for="maxwidth">Max Width</label>
            <input ref="maxwidth" name="maxwidth" :value="$store.state.max_width" />
          </td>
          <td>
            <label for="maxheight">Max Height</label>
            <input ref="maxheight" name="maxheight" :value="$store.state.max_height" />
          </td>

          <td>
            <label for="quality">Quality (0 – 1)</label>
            <input ref="quality" name="quality" :value="$store.state.file_quality" />
          </td>
        </tr>
      </tbody>
    </table>
    <table cellpadding="5">
      <tbody>
        <tr>
          <td class="suffixtd">
            <label for="name">File name suffix</label>
            <input name="name" ref="name" placeholder="ie. `–Something" :value="$store.state.filename_suffix" />
          </td>
        </tr>
        <tr>
          <td>
            <input @change="handleFiles" type="file" id="fileinput" accept="image/*" class="fileinput" ref="fileinput" multiple />
          </td>
        </tr>
        <tr>
          <td v-if="uploadedfiles && uploadedfiles.length > 0">
            <button @click.prevent="downloadAll">Download All</button>
          </td>
        </tr>
      </tbody>
    </table>

    <table cellpadding="5">
      <tbody>
        <tr>
          <td class="checkboxtd usequalityname">
            <label for="usequalityname">Only use the original file names?</label>
            <input name="usequalityname" ref="usequalityname" :checked="$store.state.use_original_file_name" type="checkbox" />
          </td>
          <td class="checkboxtd">
            <label for="includequalityname">Include original file name?</label>
            <input name="includequalityname" ref="includequalityname" :checked="$store.state.include_original_file_name" type="checkbox" />
          </td>
        </tr>
      </tbody>
    </table>

    <hr />
  </form>
  <form class="results">
    <div v-if="files">
      <transition v-for="(item, i) in files" :key="i">
        <div style="text-align: center; margin-bottom: 40px">
          <p :id="`p-${i}`"><img style="width: 50px" src="https://media1.tenor.com/m/eFde1mp-8fYAAAAC/carregando.gif" /></p>
          <canvas :id="`canvas-${i}`"></canvas>
          <img :id="`img-${i}`" />
          <br />
          <a :id="`a-${i}`">Download</a>
        </div>
      </transition>
    </div>
  </form>
</template>
<script>
/* eslint-disable no-unused-vars */
import ModelClient, { isUnexpected } from "@azure-rest/ai-inference";
import { AzureKeyCredential } from "@azure/core-auth";

const token = process.env.VUE_APP_GITHUB_API;
const endpoint = "https://models.github.ai/inference";

const client = ModelClient(endpoint, new AzureKeyCredential(token));

import { mapState } from "vuex";

import { getPNGfromBlob, getPNGfromFile, getPNGfromURL } from "tiff-to-png-client";

export default {
  name: "ImageUpload",
  props: {},
  data() {
    return {
      files: null,
      uploadedfiles: null,
      modelName: "",
    };
  },

  methods: {
    async handleFiles(e) {
      const maxsize = Math.max(this.$store.state.max_width, this.$store.state.max_height);
      this.files = Array.from(e.target.files);
      let url;

      let i = 0;
      let timer = setInterval(() => {
        if (i === this.files.length - 1) clearInterval(timer);
        if (this.files[i].type.includes("tiff")) {
          const convertFromFile = async (file) => {
            const images = await getPNGfromFile(file);
            return images;
          };
          convertFromFile(this.files[i]).then((res) => {
            url = res[0];
            this.drawCanvasImage(url, maxsize, i, this.files[i].name);
            // resolve();
          });
        } else {
          url = URL.createObjectURL(this.files[i]); //blob:http://localhost:8080/7727fed3-ede6-4e35-8583-20393c2167ff
          this.drawCanvasImage(url, maxsize, i, this.files[i].name);
        }
        i++;
      }, 2000);

      // await Promise.all(
      //   this.files.map(async (file, i) => {
      //     return new Promise((resolve) => {
      //       // If the image is a TIFF
      //       if (file.type.includes("tiff")) {
      //         const convertFromFile = async (file) => {
      //           const images = await getPNGfromFile(file);
      //           return images;
      //         };
      //         convertFromFile(file).then((res) => {
      //           url = res[0];
      //           this.drawCanvasImage(url, maxsize, i, file.name);
      //           resolve();
      //         });
      //       } else {
      //         url = URL.createObjectURL(file); //blob:http://localhost:8080/7727fed3-ede6-4e35-8583-20393c2167ff
      //         this.drawCanvasImage(url, maxsize, i, file.name);
      //         resolve();
      //       }
      //     });
      //   }),
      // );
    },

    async drawCanvasImage(url, maxsize, i, name) {
      return new Promise((resolve) => {
        const img = new Image();
        img.src = url;

        img.onload = () => {
          let width = img.width; //ie. 2100px;
          let height = img.height; //ie. 1080px
          let multiplier = Math.min(1, maxsize / Math.max(width, height));

          let canvas = document.querySelector(`#canvas-${i}`);

          // Generate the small image (small sizes) to pass thru the AI
          canvas.width = multiplier * 800;
          canvas.height = multiplier * 800;
          canvas.getContext("2d").drawImage(img, 0, 0, canvas.width, canvas.height);
          let dataUrl = canvas.toDataURL("image/*", this.$store.state.file_quality);
          let processedSmallImage = dataUrl;

          // Generate the REGULAR/SPECIFIED images (reg sizes) to pass thru the AI
          canvas.width = multiplier * width;
          canvas.height = multiplier * height;
          canvas.getContext("2d").drawImage(img, 0, 0, canvas.width, canvas.height);
          dataUrl = canvas.toDataURL("image/*", this.$store.state.file_quality);
          let processedimage = dataUrl;

          // let processedimage = {
          //   inlineData: {
          //     data: dataUrl.toString("base64").replace(/^data:image\/(png|jpg|jpeg|tif|gif);base64,/, ""),
          //     mimeType: "image/jpeg",
          //   },
          // };

          // AI rename the images, then output them in the DOM
          this.getImageName(processedSmallImage, name).then((filename) => {
            // But will need to output the larger sizes in the DOM
            console.log(filename);
            document.querySelector(`#img-${i}`).src = dataUrl;
            document.querySelector(`#a-${i}`).setAttribute("href", dataUrl);
            document.querySelector(`#a-${i}`).setAttribute("download", filename);
            document.querySelector(`#p-${i}`).innerHTML = `<textarea id="${i}" style="width:100%;max-width:400px;text-align: center">${filename}</textarea>`;
            resolve();
          });
        };
      });
    },

    async getImageName(processedimage, origname) {
      if (this.$store.state.use_original_file_name && origname) return origname.split(".")[0] + `.jpg`;

      let prompt = "Describe what's pictured. 3-6 words MAX.";

      try {
        const result = await client.path("/chat/completions").post({
          body: {
            model: this.modelName,
            messages: [
              {
                role: "user",
                content: [
                  // {
                  //   type: "text",
                  //   text: prompt,
                  // },
                  {
                    type: "image_url",
                    image_url: {
                      url: processedimage,
                      details: "low",
                    },
                  },
                ],
              },
              {
                role: "assistant",
                content: [
                  {
                    type: "text",
                    text: prompt,
                  },
                ],
              },
            ],
          },
        });
        console.log("result: ", result);
        let fileName =
          (this.$store.state.include_original_file_name ? `${origname.split(".")[0]}__` : ``) +
          result.body.choices[0].message.content.replaceAll(" ", "-").replaceAll(".", "").replaceAll(",", "") +
          this.$store.state.filename_suffix +
          `.jpg`;
        return fileName;
      } catch (err) {
        console.log("Error: ", err);
        return "Image" + this.$store.state.filename_suffix + ".jpg";
      }
    },

    resultsFormChange() {
      document.querySelector(".results").onchange = (e) => {
        let i = parseInt(e.target.getAttribute("id"));
        console.log("results change", e.target.value);
        document.querySelector(`#a-${i}`).setAttribute("download", e.target.value);
      };
    },

    formChange() {
      document.querySelector(".imageupload").onchange = (e) => {
        this.$store.commit("setMaxWidth", this.$refs.maxwidth.value);
        this.$store.commit("setMaxHeight", this.$refs.maxheight.value);
        this.$store.commit("setFileNameSuffix", this.$refs.name.value);
        this.$store.commit("setFileQuality", this.$refs.quality.value);
        this.$store.commit("setUseOriginalFileName", this.$refs.usequalityname.checked);
        this.$store.commit("setIncludeOriginalFileName", this.$refs.includequalityname.checked);
        this.$store.commit(
          "setAiModels",
          [...document.querySelectorAll("#aimodel option")].map((option) => {
            return { model: option.innerText, selected: option.selected };
          }),
        );

        this.modelName = document.querySelector("#aimodel").value;
        document.querySelector(".suffixtd").style = this.$refs.usequalityname.checked ? `opacity: .25;pointer-events: none` : ``;

        document.querySelector(".usequalityname").style = this.$refs.includequalityname.checked ? `opacity: .25;pointer-events: none` : ``;

        this.uploadedfiles = document.getElementById(`fileinput`).files;
      };
    },

    downloadAll() {
      Array.from(document.querySelectorAll("a")).forEach((a) => {
        a.click();
      });
    },
  },

  mounted() {
    this.modelName = document.querySelector("#aimodel").value;
    this.formChange();
    this.resultsFormChange();

    document.querySelector(".suffixtd").style = this.$refs.usequalityname.checked ? `opacity: .25;pointer-events: none` : ``;
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

canvas {
  max-height: 0;
  max-width: 0;
  display: inline-block;
}

img {
  display: inline-block;
  max-width: 200px;
}

table {
  width: 100%;
}

input {
  border: none;
  background: rgb(238, 238, 238);
  padding: 10px;
  display: inline-block;
  width: calc(100% - 20px);
}

form {
  text-align: left;
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
}

button {
  border: none;
  padding: 10px;
  display: inline-block;
  width: 100%;
  background: black;
  color: white;
  cursor: pointer;
}

.checkboxtd {
  width: 100%;
  display: block;
}

.checkboxtd label,
.checkboxtd input {
  display: inline-block;
  width: auto;
  vertical-align: middle;
}

.checkboxtd label {
  width: calc(100% - 30px);
}

.checkboxtd input {
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.imageupload {
  border-top: 1px solid black;
  padding-top: 15px;
}
</style>
